// Redux
import { Dispatch } from "redux";

// Classes
import { ListMembershipReducerState } from "../classes/listMembership.classes";

// Action Creators
import {
  setListMembership,
  setNewList,
  setListMembershipState
} from "../actionCreators/listMembership.actionCreators";

export const setListMembershipValue = (dispatch: Dispatch<any>, value: any) => {
  dispatch(setListMembership(value));
};

export const setNewListValue = (dispatch: Dispatch<any>, value: boolean) => {
  dispatch(setNewList(value));
};

export const initializeListMembershipState = (
  dispatch: Dispatch<any>,
  state: ListMembershipReducerState
) => {
  dispatch(setListMembershipState(state));
};
